export default "__VITE_ASSET__DsbG37n___"